import React, { useState } from 'react';
import {
  Row, Col, Table, OverlayTrigger, Tooltip,
} from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import currencyFormat from 'components/Widgets/currencyFormat';
import { useContext } from 'components/Managers/Billing/Context';
import BaseInfo from 'components/Common/Policy/Views/BaseInfo';
import Select from 'components/new_ui/Select';
import { useContext as useUsersContext } from 'components/Users/Context';
import PolicyPlan from './PolicyPlan';
import NoPlans from './NoPlans';
import Header from './Header';

export default function Policy() {
  const { state } = useContext();
  const { state: stateUsers } = useUsersContext();
  const [paymentMethod, setPaymentMethod] = useState(null);

  if (state.policy === null) {
    return (
      <>
        <Header />
        <Row>
          <Col className="py-3">
            <LoadingPlaceholder text="Loading..." />
          </Col>
        </Row>
      </>
    );
  }

  if (state.policy.attributes.plans.length === 0) {
    return (
      <>
        <Header />
        <NoPlans />
      </>
    );
  }

  const plans = state.policy.attributes.plans.filter((plan) => plan.attributes.active
    && (paymentMethod === null || (
      paymentMethod === 'free' ? plan.attributes.is_free : plan.attributes.payment_information_id === paymentMethod
    )));

  const paymentMethodsOptions = state.paymentMethods
    ? [
      { value: 'free', label: 'Free' },
      ...state.paymentMethods.map((item) => ({ value: item.id, label: item.attributes.label })),
    ]
    : [];

  const ppsTooltip = (props) => (
    <Tooltip {...props}>
      Price Per Session
    </Tooltip>
  );

  return (
    <>
      <Header policy={state.policy} />
      <BaseInfo policy={state.policy} />
      {stateUsers.user && !stateUsers.user.attributes.specific.is_billing_manager && (
        <Row className="my-2">
          <Col md={2} className="fw-light">Payment Method:</Col>
          <Col md={{ span: 4 }}>
            <Select
              id="policy-plan-payment-methods"
              placeholder={state.paymentMethods ? 'Filter by Payment Method' : 'Payment Method Loading ...'}
              isClearable
              options={paymentMethodsOptions}
              onChange={(selectedOption) => { setPaymentMethod(selectedOption ? selectedOption.value : null); }}
            />
          </Col>
        </Row>
      )}

      <Row className="mt-4">
        <Col lg={{ span: 10, offset: 1 }} xl={{ span: 10, offset: 1 }}>
          <Table responsive="sm" className="text-center align-middle">
            <thead className="text-muted align-middle">
              <tr>
                <th className="fw-light text-end">
                  Plan
                </th>

                <th className="fw-light">
                  Sessions
                </th>

                <th className="fw-light">
                  Covered Members
                </th>

                <th className="fw-light">
                  PEPM
                </th>

                <OverlayTrigger overlay={ppsTooltip}>
                  <th className="fw-light">
                    PPS
                  </th>
                </OverlayTrigger>

                <th className="fw-light">
                  Payment Method
                </th>

                <th className="fw-light bg-primary-100 rounded-top">
                  Premium
                </th>
              </tr>
            </thead>

            <tbody>
              {plans.map((plan) => <PolicyPlan key={plan.id} plan={plan} />)}
            </tbody>
            {plans && plans.length > 0 && (
            <tfoot>
              <tr className="fs-5">
                <th scope="row" colSpan={6} className="fw-normal text-end border-0">
                  Total Monthly Premium:
                </th>

                <td className="bg-primary-100 border-0 rounded-bottom fw-semibold">
                  {currencyFormat(
                    plans.reduce((sum, item) => sum + item.attributes.total_to_show, 0),
                    { currency: plans[0].attributes.currency.title },
                  )}
                </td>
              </tr>

            </tfoot>
            )}
          </Table>
        </Col>
      </Row>
    </>
  );
}
